import React, { useState, useEffect } from "react";

import { LoadingSpinner } from "@newsela/angelou";
import PropTypes from "prop-types";

import RewardIcon from "@/icons/RewardIcon";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import {
  SIZE_TYPES,
  VALUE_TYPES,
  icon,
  iconWrapper,
  layout,
  pill,
  total,
  loadingWrapper,
} from "./RewardsTotal.style";

const propTypes = {
  direction: PropTypes.oneOf(["horizontal", "vertical"]),
  sizeVersion: PropTypes.string,
  valueVersion: PropTypes.string,
  articleData: PropTypes.any,
  type: PropTypes.string,
  tokens: PropTypes.number,
};

const RewardsTotal = ({
  direction = "horizontal",
  sizeVersion = SIZE_TYPES.LARGE,
  valueVersion = VALUE_TYPES.SINGLE_VALUE,
  articleData,
  type,
  tokens,
}) => {
  const { data: user } = useUser();
  const { isTeacher } = getUserProperties(user);
  const [totalTokens, setTotalTokens] = useState(tokens || 0);
  const [earnedTokens, setEarnedTokens] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(articleData?.data || articleData);

  useEffect(() => {
    setData(articleData?.data || articleData);
  }, [articleData]);

  useEffect(() => {
    if (!tokens && data?.topic_id) {
      const existedType = data?.interactions?.filter(
        (interaction) =>
          interaction.type === type?.toLowerCase().replace(" ", "_"),
      )[0];
      if (existedType) {
        setTotalTokens(existedType.tokens);
        setEarnedTokens(existedType.earned_tokens);
      } else {
        setTotalTokens(data?.tokens);
        setEarnedTokens(data?.earned_tokens);
      }
      setIsLoading(false);
    }
  }, [data]);

  const typeHasData = () => {
    if (type) {
      const existedType = data?.interactions?.filter(
        (interaction) =>
          interaction.type === type?.toLowerCase().replace(" ", "_"),
      )[0];
      return !!existedType;
    }
    return true;
  };

  return articleData && !articleData?.error_message && typeHasData() ? (
    <div css={layout(direction)}>
      {isLoading ? (
        <LoadingSpinner __cssFor={{ root: loadingWrapper }} />
      ) : (
        <>
          <div css={iconWrapper(sizeVersion, direction)}>
            <RewardIcon css={icon} aria-hidden={true} />
          </div>
          <div css={pill(sizeVersion, direction)}>
            {valueVersion === VALUE_TYPES.DOUBLE_VALUE ? (
              <span css={total}>{` ${earnedTokens} / ${totalTokens}`}</span>
            ) : (
              <span css={total}>{isTeacher ? totalTokens : earnedTokens}</span>
            )}
          </div>
        </>
      )}
    </div>
  ) : null;
};

RewardsTotal.propTypes = propTypes;
export default RewardsTotal;
